import { Component, ElementRef, Input, Output, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import {
  FeatureMap,
  MarkerComponent,
  SizeUnit, SIZE_UNIT,
  VerticalAlignment, VERTICAL_ALIGNMENT,
  HorizontalAlignment, HORIZONTAL_ALIGNMENT
} from '@realpage-da/ng-map';

@Component({
  selector: 'market-marker',
  template: `
  <div (click)="onMouseEvent.next('click')"
  (mouseenter) = "onMouseEvent.next('mouseenter')"
  (mouseleave) = "onMouseEvent.next('mouseleave')"
  class="badge-xs-gray">
</div>`,
  styleUrls: ['./market-marker.component.scss']
})
export class MarketMarkerComponent extends MarkerComponent implements OnDestroy {
  map: FeatureMap;

  defaultColor: string = '#61676B';

  sizeUnit = SIZE_UNIT.EM as SizeUnit;
  horizontalAlignment = HORIZONTAL_ALIGNMENT.CENTER as HorizontalAlignment;
  verticalAlignment = VERTICAL_ALIGNMENT.ABOVE as VerticalAlignment;

  width = 1.5;
  height = 1.5;
  baseZoom: number = 8;
  scaleFactor: number = 1.5;

  ngOnInit() { }

  // setColor(color: string = this.defaultColor) {
  //   if (color === this.color || !this.element.nativeElement.firstChild) return this;
  //   this.element.nativeElement.firstChild.style.backgroundColor = color;
  //   return this;
  // }
}



// WEBPACK FOOTER //
// ./src/app/features/market/components/map/market-marker.component.ts